import React from 'react'
import { Card, Col, Container, Image, Row } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { HiLocationMarker } from 'react-icons/hi';
import { ImUsers } from 'react-icons/im';
import { FaUsers } from 'react-icons/fa';
import { GrDocumentVerified } from 'react-icons/gr';
import { FaBuilding } from 'react-icons/fa';
import { AvField, AvForm } from 'availity-reactstrap-validation';
import CountUp from 'react-countup';
import Clients from './Clients';
import Accordion from 'react-bootstrap/Accordion';
export default function About() {
    return (
        <>
            <section className='banner_strip'>
             <h1>CAREER FAQ</h1>
            </section>
            <div className='job-page about-page'>
            <Container fluid style={{padding:0}}>
            <nav aria-label="breadcrumb">
            <ol className="breadcrumb">
                <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                <li className="breadcrumb-item active" aria-current="page">Faq</li>
            </ol>
            </nav>
            </Container>
                <div className='section-page'>
                    <Container fluid>
                        <Row>
                            <Col>
                             <h1 className='title-heading op_heading color-dark'>Career Faq</h1>
                            </Col>
                            <Accordion defaultActiveKey="0">
                                <Accordion.Item eventKey="0">
                                    <Accordion.Header>Dummy text lorem ipsum dolor sit amet</Accordion.Header>
                                    <Accordion.Body>
                                        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                                        eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad
                                        minim veniam, quis nostrud exercitation ullamco laboris nisi ut
                                        aliquip ex ea commodo consequat. Duis aute irure dolor in
                                        reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla
                                        pariatur. Excepteur sint occaecat cupidatat non proident, sunt in
                                        culpa qui officia deserunt mollit anim id est laborum.
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="1">
                                    <Accordion.Header>Another dummy text lorem ipsum</Accordion.Header>
                                    <Accordion.Body>
                                        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                                        eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad
                                        minim veniam, quis nostrud exercitation ullamco laboris nisi ut
                                        aliquip ex ea commodo consequat. Duis aute irure dolor in
                                        reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla
                                        pariatur. Excepteur sint occaecat cupidatat non proident, sunt in
                                        culpa qui officia deserunt mollit anim id est laborum.
                                    </Accordion.Body>
                                </Accordion.Item>
                            </Accordion>
                        </Row>
                    </Container>
                </div>


            </div>
            <Clients />
        </>
    )
}
